import { useState, useEffect } from "react";
import pageTop from '../../img/pagetop.svg';

const ScrollTop = (props) => {
    const [isVisible, setIsVisible] = useState(false);

    // Function to check scroll position
    const handleScroll = () => {
        if (window.scrollY > 100) { // Show button after 200px scroll
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Scroll to top function
    const handleScrollToTop = (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // Add scroll event listener
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <a 
            href="#top" 
            className={`pagetop ${isVisible ? "show" : "hide"}`} 
            onClick={handleScrollToTop}
        >
            <img src={pageTop} alt="PageTop" {...props} />
        </a>
    );
};

export default ScrollTop;
